export default __webpack_public_path__ + "static/media/camera.be662bd7.svg";